// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"dd421994","726":"3b491e5e","787":"f2f8132b"}[chunkId] + ".chunk.js";
};